// Overgrazing field (VS study — the "director", spatialized). Eating a
// microbe marks its grid cell as grazed; grazed cells suppress microbe
// respawns and recover slowly. Camping one spot starves you outward, so
// hunger — not a clock — forces the crescendo. See amoeba-vs-study.md.
//
// Module-scope state for the single game instance, same pattern as
// damage.ts edge-detection state. Reset per life in lifecycle.doRespawn:
// the world reseeds on death, so the buffet resets with it.

import { T } from './tunables'

const cells = new Map<string, number>() // cellKey → graze level 0..1

function cellKey(x: number, y: number): string {
  const s = T.graze.cellSize
  return `${Math.floor(x / s)},${Math.floor(y / s)}`
}

/** Graze level 0 (untouched) → 1 (stripped bare) at a world position. */
export function grazeAt(x: number, y: number): number {
  return cells.get(cellKey(x, y)) ?? 0
}

/** Called when a microbe is eaten at (x, y). */
export function addGraze(x: number, y: number): void {
  const key = cellKey(x, y)
  cells.set(key, Math.min(1, (cells.get(key) ?? 0) + T.graze.perEat))
}

/** Regrow all grazed cells; drop fully-recovered ones from the map. */
export function grazeSystem(dt: number): void {
  const regen = T.graze.regenPerSec * dt
  for (const [key, level] of cells) {
    const next = level - regen
    if (next <= 0) cells.delete(key)
    else cells.set(key, next)
  }
}

export function resetGraze(): void {
  cells.clear()
}
